export type FuseAlertAppearance = 'border' | 'fill' | 'outline' | 'soft';

export type FuseAlertType =
  | 'primary'
  | 'accent'
  | 'warn'
  | 'basic'
  | 'info'
  | 'success'
  | 'warning'
  | 'error';
